import React from 'react'
import * as tracker from '@btime/tracker'
import { getSubdomain } from '../helpers/url'
import { getLoggedUser } from '../session/sessionStorage'
import { globalHistory } from '@reach/router'

export const TrackerContext = React.createContext(() => () => {})
export const TrackerProvider = ({ children }) => {
  tracker.init(getSubdomain(), getLoggedUser(), 'front')

  React.useEffect(() => {
    globalHistory.listen(({ location }) => {
      tracker.pageView({ page: location.pathname })
    })
  }, [])

  return <TrackerContext.Provider children={children} />
}
